import { runOpportunityInitialization } from '../../services/oneButtonServices/runOpportunityInitialization';
import { useOneButtonStore } from '../../store/oneButtonStore';

const pendingHydrations = new Map<string, Promise<boolean>>();

/**
 * Load the same opportunity/product/design bundle used by Dashboard V2.
 * Concurrent pre-contract consumers share one request per Salesforce ID.
 */
export function ensurePreContractOpportunityHydrated(salesForceId: string): Promise<boolean> {
    const sfid = salesForceId.trim();
    if (!sfid) return Promise.resolve(false);

    const state = useOneButtonStore.getState();
    if (
        state.opportunityInitializedSfid === sfid &&
        state.opportunityDetails &&
        state.opportunityID
    ) {
        return Promise.resolve(true);
    }

    const pending = pendingHydrations.get(sfid);
    if (pending) return pending;

    const hydration = (async () => {
        const store = useOneButtonStore.getState();
        store.setSalesForceId(sfid);
        const requestId = store.beginOpportunityInitialization(sfid);
        await runOpportunityInitialization({
            salesForceId: sfid,
            requestId,
            waitForSiteDesign: false,
        });

        const latest = useOneButtonStore.getState();
        return (
            latest.opportunityInitializedSfid === sfid &&
            Boolean(latest.opportunityDetails) &&
            Boolean(latest.opportunityID)
        );
    })().finally(() => {
        pendingHydrations.delete(sfid);
    });

    pendingHydrations.set(sfid, hydration);
    return hydration;
}
